export default "/assets/images/social-youtube.svg";